import { createSelector } from 'reselect';

export const selectedSearchMissions = (state: any) => {
  return state.get('searchMissions');
};

const makeSelectedMissions = () =>
  createSelector(selectedSearchMissions, searchMissions => {
    if (searchMissions && searchMissions.get('foundMissions')) {
      const foundMissions = searchMissions.get('foundMissions').toJS();
      return foundMissions;
    }
    return null;
  });

export { makeSelectedMissions };
